export default __webpack_public_path__ + "static/media/over-ons-headshot.c764a1d1.webp";